import { render, staticRenderFns } from "./FiltersTable.vue?vue&type=template&id=1a5d6b64&scoped=true"
import script from "./FiltersTable.vue?vue&type=script&lang=js"
export * from "./FiltersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d6b64",
  null
  
)

export default component.exports